import type { ReactNode } from 'react';

interface PlayZoomStageProps {
  revealed?: boolean;
  countdown?: ReactNode;
  children: ReactNode;
}

/** Cadre carré centré pour l'affichage des crops en jeu. */
export function PlayZoomStage({ revealed, countdown, children }: PlayZoomStageProps) {
  return (
    <div className={`zoom-stage${revealed ? ' is-revealed' : ''}`}>
      <div className="zoom-viewport">
        <div className="zoom-viewport-inner">
          {children}
        </div>
        {countdown}
      </div>
    </div>
  );
}
